import { AxiosResponse } from "axios";
import { BASE_URL } from "../helper";
import authService from "./authService";

class ApiService {
  private baseUrl: string;

  constructor(baseUrl: string = `${BASE_URL}`) {
    this.baseUrl = baseUrl;

  }

  async get<T>(endpoint: string): Promise<AxiosResponse> {
    const response = await authService.authenticatedRequest<T>(`${this.baseUrl}${endpoint}`, 'get');
    return response;
  }

  async post<T>(endpoint: string, data: any): Promise<AxiosResponse> {
    const response = await authService.authenticatedRequest<T>(`${this.baseUrl}${endpoint}`, 'post',data)
    return  response;
  }

  async put<T>(endpoint: string, data: any): Promise<AxiosResponse> {
    const response = await authService.authenticatedRequest<T>(`${this.baseUrl}${endpoint}`, 'put', data)
    return response;
  }

  async delete<T>(endpoint: string): Promise<AxiosResponse> {
    const response = await authService.authenticatedRequest<T>(`${this.baseUrl}${endpoint}`,'delete') 
    return response;
  }
}

export const apiService = new ApiService();
export default apiService;